"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GIFT_AID_PLUS_VALUE_PERCENTAGE = void 0;
exports.GIFT_AID_PLUS_VALUE_PERCENTAGE = 0.25;
